import React from 'react';
import { Github, ExternalLink, ArrowRight } from 'lucide-react';
import './Projects.css';

// --- YOUR PROJECTS ---
const MY_PROJECTS = [
  {
    id: 1,
    title: "Automated Threat Intelligence Feed",
    description: "A Python-based tool that aggregates IP reputation data from AbuseIPDB and AlienVault OTX.",
    tech: ["Python", "API", "Threat Intel"],
    github: "https://github.com/YOUR_USERNAME/PROJECT_1", 
    link: "https://demo-link.com" 
  },
  {
    id: 2,
    title: "Corporate Network Traffic Analyzer",
    description: "Analyzed 50GB of PCAP data to identify beaconing malware and data exfiltration attempts.",
    tech: ["Wireshark", "Zeek", "Python"],
    github: "https://github.com/YOUR_USERNAME/PROJECT_2",
    link: null
  },
  {
    id: 3,
    title: "Secure File Storage System",
    description: "Encrypted file storage solution using AES-256 and role-based access control.",
    tech: ["Node.js", "Cryptography", "React"],
    github: "https://github.com/YOUR_USERNAME/PROJECT_3",
    link: null
  }
];

const Projects = ({ data }) => {
  const projects = data || MY_PROJECTS;

  return (
    <section className="projects-section" id="deployed-projects">
      <div className="projects-container">
        
        {/* =========================================
            DEPLOYED PROTOCOLS
           ========================================= */}
        <div className="section-header">
            <h2 className="section-title">DEPLOYED_PROJECTS</h2>
            <p className="section-subtitle">Active Security Tools & Case Studies</p>
        </div>

        <div className="projects-grid">
        {projects.map((project) => (
            <div 
              key={project.id} 
              className="project-card clickable-card"
              onClick={() => project.github && window.open(project.github, '_blank')}
              style={{ cursor: project.github ? 'pointer' : 'default' }}
            >
              <div className="project-content">
                <div className="project-header">
                  <span className="project-id">PRJ-{project.id.toString().padStart(3, '0')}</span>
                  <div className="project-links">
                      {project.github && (
                      <a 
                        href={project.github} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="icon-link"
                        onClick={(e) => e.stopPropagation()}
                      >
                          <Github size={20} />
                      </a>
                      )}
                      {project.link && (
                      <a 
                        href={project.link} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="icon-link"
                        onClick={(e) => e.stopPropagation()}
                      >
                          <ExternalLink size={20} />
                      </a>
                      )}
                  </div>
                </div>

                <h3 className="project-title">{project.title}</h3>
                <p className="project-desc">{project.description}</p>

                <div className="tech-stack">
                {project.tech.map((tech, i) => (
                    <span key={i} className="tech-tag">{tech}</span>
                ))}
                </div>

                <div className="project-footer">
                    <ArrowRight size={16} className="arrow-icon" />
                </div>
              </div>
              
              <div className="project-overlay"></div>
            </div>
        ))}
        </div>

      </div>
    </section>
  );
};

export default Projects;